import Vue from 'vue';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import { firebase } from 'mostra';
// import * as firebase from '@/plugins/firebase';

const initial = () => {
  console.log(process.env.VUE_APP_SENTRY_URL);
  if (process.env.VUE_APP_SENTRY_URL) {
    console.log('Use sentry!');
    Raven.config(process.env.VUE_APP_SENTRY_URL, {
      autoBreadcrumbs: {
        console: true,
        location: true,
      },
    }).addPlugin(RavenVue, Vue).install();

    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        console.log('Set user context in Sentry');
        Raven.setUserContext({
          id: user.uid,
          email: user.email,
        });
        Raven.setExtraContext({
          isAnonymous: user.isAnonymous,
        });
      } else {
        console.log('Clear user context in Sentry');
        Raven.clearContext();
      }
    });
  } else {
    console.log('Not use sentry!');
  }
  // Object.defineProperty(Vue.prototype, '$raven', {
  //   get() { return this; },
  // });
};

const captureException = (error: Error) => {
  console.error(error);
  if (process.env.VUE_APP_SENTRY_URL) {
    Raven.captureException(error);
  }
};

export default { captureException, initial };
